import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

const CropperModal = ({ cropperRef, show, croppedImage, croppieClose, handleHide, modalWidth, from, postWidth, productCroppie, croppie }) => {
    const [zoomLevel, setZoomLevel] = useState(0.0001);
    // Set the modal heading dynamically
    const setHeading = () => {
        if (from === "editor-link") {
            return "Crop Link Image";
        } else if (from === "banners") {
            return "Crop Profile Banner";
        } else {
            return "Crop Image";
        }
    };
    const handleSliderChange = (event) => {
        const value = parseFloat(event.target.value);
        setZoomLevel(value); // Update zoom level
        if (cropperRef.current) {
          const cropper = cropperRef.current.cropper;
          cropper.zoomTo(value); // Zoom the cropper
        }
      };
      const handleWheel = (event) => {
        event?.preventDefault(); // Prevent default scrolling
        const delta = event.deltaY < 0 ? 0.1 : -0.1; // Determine zoom direction
        const newZoomLevel = Math.min(Math.max(zoomLevel + delta, 0.0001), 3); // Limit zoom level between 0.5 and 3
        setZoomLevel(newZoomLevel); // Update zoom level
        if (cropperRef.current) {
          const cropper = cropperRef.current.cropper;
          cropper.zoomTo(newZoomLevel); // Zoom the cropper
        }
      };
    const width =  productCroppie == "productCroppie" ? "productCroppie" : postWidth ? "postWidth" : "productModal";
    return (
        <Modal centered show={show} onHide={handleHide} id={modalWidth ? width : "ppModal"}>


            <Modal.Header class="modal-header create-biolink-header py-2 px-3">
                <h5 class="modal-title">
                    {setHeading()}
                </h5>
                <button type="button" class="close" onClick={croppieClose} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div id="image_demo2" onWheel={handleWheel} style={modalWidth ? null : { width: "350px", margin: "0 auto", marginTop: "30px" }}>
                            {croppie && (
                                <Cropper
                                ref={cropperRef}
                                src={croppie}
                                style={{ height: 470, width: "100%" }}
                                minCropBoxWidth={850}
                                maxCropBoxWidth={850}
                                minCropBoxHeight={470}
                                maxCropBoxHeight={470}
                                guides={true}
                                viewMode={2}
                                background={false}
                                autoCropArea={1}
                                checkOrientation={false}
                                cropBoxResizable={false}
                                cropBoxMovable={true}
                                zoomable={true}
                                mouseWheelZoom={false} 
                                dragMode="move"
                              />
                            )}
                            <div className="cr-slider-wrap mt-2">
                                <input
                                className="cr-slider"
                                    type="range"
                                    min="0.0001"
                                    max="3"
                                    step="0.0001"
                                    value={zoomLevel}
                                    onChange={handleSliderChange} 
                                />
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
                        <button type="button" onClick={croppieClose} class="fs-12 w-50 mt-0 integration-btns integration-btn-grey">
                            Cancel
                        </button>
                        <button type="button" onClick={croppedImage} class="fs-12 w-50 shadow-none  project-blue-btn">
                            Crop and Upload
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CropperModal;
